import React from 'react';
import { SectionCard } from '../../common/SectionCard';
import { DocumentStatusBadge } from '../../common/StatusPills';
import { ScoreChip } from '../../common/ScoreChip';
import { formatAed, formatDate } from '../../../utils/format';
import { entityName } from '../../../data/entities';
import type { ApplicationRecord } from '../../../types/domain';
export function AssessmentPanel({
  record
}: {
  record: ApplicationRecord;
}) {
  return <div className="space-y-4" data-id="element-564" data-mp="2qk5symykc999">
      <SectionCard title="Assessment summary" description={record.summary} data-id="element-565" data-mp="2qgrq7dlzly1a">
        <dl className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-566" data-mp="2ukfvfpn5chjd">
          <div data-id="element-567" data-mp="2zi7xvdlf3m1t">
            <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-568" data-mp="2zhpuzy4929kx">
              Applying entity
            </dt>
            <dd className="mt-1 text-[13px]" data-id="element-569" data-mp="26ulkxeqav52a">{entityName(record.entityId)}</dd>
          </div>
          <div data-id="element-570" data-mp="26sr7elhcyf88">
            <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-571" data-mp="2btf15ewz1a65">
              Host body
            </dt>
            <dd className="mt-1 text-[13px]" data-id="element-572" data-mp="3it6ir3zek2b5">{record.hostBody}</dd>
          </div>
          <div data-id="element-573" data-mp="3ese57yjhzb92">
            <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-574" data-mp="3etpci8c5j14x">
              Support requested
            </dt>
            <dd className="mt-1 font-mono text-[13px]" data-id="element-575" data-mp="39zl0vbrxy4xi">
              {formatAed(record.requestedSupportAed)}
            </dd>
          </div>
          <div data-id="element-576" data-mp="304053vdgu0w7">
            <dt className="text-[11px] uppercase tracking-[0.08em] text-muted-foreground" data-id="element-577" data-mp="304jcii5hp6vz">
              Weighted score
            </dt>
            <dd className="mt-1" data-id="element-578" data-mp="2v6rinilabap5">
              <ScoreChip score={record.aiScore} showBand data-id="element-579" data-mp="2r2jv3oqkc0si" />
            </dd>
          </div>
        </dl>
      </SectionCard>

      <SectionCard title="Criterion scoring" description="Preset weighted criteria applied to this track and stage" bodyClassName="p-0" data-id="element-580" data-mp="2m50dqfykj7wc">
        <ul className="divide-y divide-border" data-id="element-581" data-mp="kcvjuyxie0iz">
          {record.criteria.map(criterion => <li key={criterion.id} className="px-4 py-3" data-id="element-582" data-mp="13hh0hjlofhrz">
              <div className="flex items-center justify-between gap-3" data-id="element-583" data-mp="13fxjfqs752p5">
                <p className="text-[13px] font-medium" data-id="element-584" data-mp="188qs2pqscv6i">{criterion.label}</p>
                <span className="shrink-0 font-mono text-[12px] text-muted-foreground" data-id="element-585" data-mp="uh2dmft2dumd">
                  {criterion.score} · weight {criterion.weight}%
                </span>
              </div>
              <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-muted" data-id="element-586" data-mp="1n4okpy1i3hdz">
                <div className="h-full rounded-full bg-uae-green" style={{
              width: `${criterion.score}%`
            }} data-id="element-587" data-mp="1r6ji4rgb9amh" />
              </div>
              <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground" data-id="element-588" data-mp="1d9ejhcixfe19">
                {criterion.evidence}
              </p>
            </li>)}
        </ul>
      </SectionCard>

      <SectionCard title="Submitted documents" description="Verification state of every artefact attached to the application" bodyClassName="p-0" data-id="element-589" data-mp="1u7upnbwb3b0">
        <ul className="divide-y divide-border" data-id="element-590" data-mp="3vb07qm98bzor">
          {record.documents.map(document => <li key={document.id} className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-591" data-mp="3qdgnn5puosow">
              <div className="min-w-0" data-id="element-592" data-mp="8612xehlmiel">
                <p className="truncate text-[13px]" data-id="element-593" data-mp="38is1ik0tt3y">{document.label}</p>
                <p className="text-[11px] text-muted-foreground" data-id="element-594" data-mp="377p1kyegpdw">
                  Updated {formatDate(document.updatedOn)}
                </p>
              </div>
              <DocumentStatusBadge status={document.status} data-id="element-595" data-mp="37otnn1mj6ti6" />
            </li>)}
        </ul>
      </SectionCard>
    </div>;
}